import {parseCategoryImageForConfig} from './categoryImageParser';

/**
 * Get initial form values with fallback logic
 * @param {string} primaryCategoryId - Primary category ID
 * @param {boolean} initialUseLabImage - Initial use lab image flag
 * @param {Object} imageConfig - Image configuration from Algolia
 * @param {Array} categoryImages - Array of category image objects
 * @returns {Object} Initial form values
 */
export default function getInitialFormValues(
  primaryCategoryId,
  initialUseLabImage,
  imageConfig,
  categoryImages
) {
  const baseDefaults = {
    assetHash: '',
    autoNegate: 0,
    colorId: null,
    debopacity: null,
    design: '',
    digest: '',
    imdeboss: false,
    imengrave: false,
    ixbg: '',
    ixfm: '',
    ixh: null,
    ixq: null,
    ixw: null,
    noauto: false,
    opacity: null,
    placeMax: 0,
    placeMaxCenter: null,
    placeMaxPct: null,
    placeUseProduct: 0,
    placeUseView: 'front',
    useLabImage: Boolean(initialUseLabImage)
  };

  // Priority 1: Use imageConfig from Algolia if available
  if (imageConfig && typeof imageConfig === 'object') {
    const result = {
      ...baseDefaults,
      ...imageConfig,
      imdeboss: Boolean(imageConfig.imdeboss),
      // Convert binary integers to booleans for UI components
      imengrave: Boolean(imageConfig.imengrave),
      noauto: Boolean(imageConfig.noauto)
    };

    return result;
  }

  // Priority 2: Fallback to parsing category image URL
  if (categoryImages && primaryCategoryId) {
    const {hash, initialValues} = parseCategoryImageForConfig(
      categoryImages,
      primaryCategoryId
    );
    const result = {
      ...baseDefaults,
      ...initialValues,
      assetHash: hash
    };

    return result;
  }

  return baseDefaults;
}
